import IResult from '../../models/result/IResult';
import { sendPost } from './generic';

export interface SessionInsightsChatMessage {
    role: 'user' | 'assistant';
    text: string;
}

export interface SessionInsightsSessionReference {
    sessionId: string;
    applicationId: string;
}

export interface SessionInsightsChatRequest {
    sessions: SessionInsightsSessionReference[];
    startDate: string;
    endDate: string;
    messages: SessionInsightsChatMessage[];
    /** Dashboard the modal belongs to (FOOD_ORDERING, HEALTHCARE, OUTBOUND_CALLING); tailors the prompts */
    domain?: string;
    /** "Load more": how many ranked keyword matches were already reviewed */
    offset?: number;
    /** "Load more": phrases from the first answer, so the ranking stays the same */
    searchPhrases?: string[];
}

export interface SessionInsightsMatch {
    sessionId: string;
    applicationId: string;
    reason: string;
}

export interface SessionInsightsChatResponse {
    answer: string;
    matches: SessionInsightsMatch[];
    searchPhrases: string[];
    sessionsReviewed: number;
    candidateCount: number;
    offset: number;
    nextOffset: number;
    hasMore: boolean;
}

export const sendSessionInsightsChat = (request: SessionInsightsChatRequest): Promise<IResult<SessionInsightsChatResponse>> => {
    return sendPost<SessionInsightsChatResponse>('/SessionInsights/Chat', request);
};
